import { Record } from 'immutable';

const ConfigSourceRecord = Record({
    image: '',
    widget: '',
});

class ConfigSourceModel extends ConfigSourceRecord {}

export default ConfigSourceModel;
